import React, { useEffect } from 'react';
import { MotionConfig } from 'framer-motion';
import { initMetaPixel } from './utils/metaPixel';
import { CountdownBar } from './components/CountdownBar';
import { Hero } from './components/Hero';
import { StatsBar } from './components/StatsBar';
import { Difference } from './components/Difference';
import { Recognize } from './components/Recognize';
import { WhatsInside } from './components/WhatsInside';
import { InsidePages } from './components/InsidePages';
import { Bonuses } from './components/Bonuses';
import { HowItWorks } from './components/HowItWorks';
import { Audience } from './components/Audience';
import { Offer } from './components/Offer';
import { Guarantee } from './components/Guarantee';
import { Testimonials } from './components/Testimonials';
import { Faq } from './components/Faq';
import { FinalCta } from './components/FinalCta';
import { Footer } from './components/Footer';
export function App() {
  useEffect(() => {
    initMetaPixel();
    document.documentElement.lang = 'pl';
    document.title = 'WF GOTOWY™ – Gotowe lekcje WF dla klas 1–8';
  }, []);
  return <MotionConfig reducedMotion="user" data-id="element-0" data-mp="3mkhmhu9cv461">
      <div lang="pl" className="w-full bg-stone-50 font-sans text-slate-900 antialiased" data-id="element-1" data-mp="3mjg8bgx1m1k3">
        <CountdownBar data-id="element-2" data-mp="3rd191gq0t9mz" />
        <main data-id="element-3" data-mp="5yjsutqtdfe">
          <Hero data-id="element-4" data-mp="5opiv1o0k3w" />
          <StatsBar data-id="element-5" data-mp="680frswe88f" />
          <Difference data-id="element-6" data-mp="5gez9t0lqvv" />
          <Recognize data-id="element-7" data-mp="82jt1oitsae" />
          <WhatsInside data-id="element-8" data-mp="2zl3dbpgpde7f" />
          <InsidePages data-id="element-9" data-mp="2zlv7qwykd5w4" />
          <Bonuses data-id="element-10" data-mp="2zmo557bmuj1l" />
          <HowItWorks data-id="element-11" data-mp="2zn6b4vo3kbmp" />
          <Audience data-id="element-12" data-mp="33morde4z3yj7" />
          <Offer data-id="element-13" data-mp="33lwy49yumcw3" />
          <Guarantee data-id="element-14" data-mp="33ngf62sbwryx" />
          <Testimonials data-id="element-15" data-mp="33mykvbp88ntn" />
          <Faq data-id="element-16" data-mp="38lrnua6w0wfk" />
          <FinalCta data-id="element-17" data-mp="38l8hzruihyhw" />
        </main>
        <Footer data-id="element-18" data-mp="38l06a3a4kz8a" />
      </div>
    </MotionConfig>;
}